<template>
  <div class="partyterminal">
    <div class="header">
      <!-- <div class="title">智慧党建平台终端覆盖</div> -->
      <img :src="party1" alt="">
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <div>{{ item.title }}</div>
          <img :src="item.logo" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import partyterminal1 from "../../../assets/party/partyterminal1.png";
import partyterminal2 from "../../../assets/party/partyterminal2.png";
import partyterminal3 from "../../../assets/party/partyterminal3.png";

import party1 from '../../../assets/party/party1.png'

export default {
  setup() {
    return reactive({
      party1:party1,
      list: [
        {
          id: 1,
          title: "PC端",
          logo: partyterminal1,
        },
        {
          id: 2,
          title: "移动端",
          logo: partyterminal2,
        },
        {
          id: 3,
          title: "终端设备",
          logo: partyterminal3,
        },
      ],
    });
  },
};
</script>

<style scoped>
.partyterminal {
  width: 1180px;
  margin: 80px auto 0;
}
.header {
  text-align: center;
}
.header img {
  width: 323px;
  margin: 0 auto;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #a2231d;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}
.body .list {
  display: flex;
  justify-content: space-between;
}
.body .list .item {
  width: 260px;
  padding: 40px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px 20px 20px 20px;
  text-align: right;
}
.body .list .item:nth-of-type(2) img {
  width: 88px;
}
.body .list .item div {
  font-size: 24px;
  color: #3d3d3d;
  text-align: left;
}
.body .list .item img {
  width: 177px;
  margin-top: 5px;
  
}
</style>
